import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import CustomBreadcrumb from '../../common/CustomBreadcrumb'
import CommonTable from '../../common/CommonTable';
import { aiCampaignsColumns } from './aiCampaignsUtils';
import { ThemeContext } from '../../common/themeContext';
import Loader from '../Loder/loader';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getAllAiCampaignsHandler } from '../../redux/action/getAllAiCampaignsSlice';

const AiCampaigns = () => {
    const navigate = useNavigate();
    const columns = aiCampaignsColumns(navigate);

    const { brandId } = useContext(ThemeContext);
    const dispatch = useDispatch();
    const getAllAiCampaignsState = useSelector((state) => state?.getAllAiCampaigns);
    const [campaigns, setCampaigns] = useState([]);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20],
        className: "order-pagination",
        locale: { items_per_page: "" },
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
    });

	const normalizeCampaignStatus = (status) => {
        if (!status) return status;
        if (typeof status !== 'string') return status;

        const map = {
            HOLD: "Hold",
            ACTIVE: "Active",
            ARCHIVE: "Archive",
            DRAFT: "Draft",
        };

        const trimmed = status.trim();
        if (map[trimmed]) return map[trimmed];

        // Fallback: turn "hold" -> "Hold", "ACTIVE" -> "Active"
        return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
    };

    const normalizeCampaignDuration = (item) => {
        // Prefer backend-provided duration if present.
        if (item?.campaignDuration) return item.campaignDuration;

        const start = item?.campaignStartDate
        const end = item?.campaignEndDate
        if (start && end) {
            const startFormatted = moment(start).format('MM/DD/YYYY');
            const endFormatted = moment(end).format('MM/DD/YYYY');
            return `${startFormatted} - ${endFormatted}`;
        }
        return '';
    };

	const initialPayload = useMemo(() => {
        return {
            refBrandId: brandId, // i check with dynamic brnadId but not work so set statically
            campaignType: "ENROLLMENT",
            status: null,
        };
    }, [brandId]);

    useEffect(() => {
        const offSet = 1;
        const limit = pagination.pageSize;
        if (!brandId) return;

        window.scrollTo(0, 0);
        dispatch(getAllAiCampaignsHandler({ ...initialPayload, offSet, limit }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [brandId]);

    useEffect(() => {
        const items = getAllAiCampaignsState?.data?.data;
        if (!items) return;

        const mapped = items.map((item) => ({
            // Keep key for antd Table stability; fall back to campaignName.
            key: item?.id ?? item?.campaignId ?? item?.campaignName,
            campaignName: item?.campaignName ?? item?.name ?? "",
            campaignType: item?.campaignType ?? item?.type ?? "",
            campaignDuration: normalizeCampaignDuration(item),
            status: normalizeCampaignStatus(item?.status),
            ...item,
        }));

        setCampaigns(mapped);

        setPagination((prev) => ({
            ...prev,
            total: getAllAiCampaignsState?.data?.totalElements ?? 0,
            current: getAllAiCampaignsState?.data?.pageNumber ?? 1	,
            pageSize: getAllAiCampaignsState?.data?.pageSize ?? prev.pageSize,
        }));
    }, [getAllAiCampaignsState]);

    const addProduct = () => {
        navigate("/ai-campaigns/campaign-details", { state: null });
    };

    const handlePageChange = (page, pageSize) => {
        if (!brandId) return;
        window.scrollTo(0, 0);
        dispatch(getAllAiCampaignsHandler({ ...initialPayload, offSet: page, limit: pageSize }));
    };
    return (
        <div className="rightside">
            <div className="rightcontent">
                <p>
                    <strong>Campaign List</strong>
                </p>
                <CustomBreadcrumb
                    items={[{ text: "Home" }, { text: "AI Campaigns" }, { text: "Campaign List", active: true }]}
                />

                <div className="table-padding">
                    <div className="headtitle">
                        <p className="mb-0 heedprodct">Campaign List</p>
                        <button className="primarybtn" onClick={addProduct}>
                            <div className="plus"></div>
                            Create Enrollment Campaign
                        </button>
                    </div>
                    <hr className="m-0" />
                    <div className="table-responsive">
                        {getAllAiCampaignsState?.isLoading === true && (
                            <Loader loaderTransform="loaderTransform" />
                        )}
                        <CommonTable
                            handlePageChange={handlePageChange}
                            pagination={pagination}
                            body={campaigns}
                            columns={columns}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AiCampaigns